import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export function addAnonIdToParams(
    params: Record<string, string>,
    analyticsClient: { getAnonymousId: () => string } | null
): Record<string, string> {
    const anonymousId = analyticsClient?.getAnonymousId();
    if (
        !anonymousId ||
        !checkFeatureFlagGate(featureFlags.lad13HandoverAnonIdOnLoomSignupFlow)
    ) {
        return params;
    }
    return { ...params, anon_id: anonymousId };
}
